import { render } from "./BtnOrange.vue?vue&type=template&id=cfd540fe&scoped=true"
import script from "./BtnOrange.vue?vue&type=script&lang=js"
export * from "./BtnOrange.vue?vue&type=script&lang=js"

import "./BtnOrange.vue?vue&type=style&index=0&id=cfd540fe&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfd540fe"]])

export default __exports__